/**
 * DescriptionLogo component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';
import DeviceConfig from '@devices/config';

/**
 * Styled image for the description logo.
 */
const DescriptionLogo = styled.img`
  width: ${60 * Screen.widthRatio}px;
  margin-left: ${39 * Screen.widthRatio}px;
  ${() =>
    !DeviceConfig.capabilities.disableAnimations
      ? `filter: drop-shadow(
    ${2 * Screen.widthRatio}px ${4 * Screen.widthRatio}px
      ${4 * Screen.widthRatio}px #000000
  );
  -webkit-filter: drop-shadow(
    ${2 * Screen.widthRatio}px ${4 * Screen.widthRatio}px
      ${4 * Screen.widthRatio}px #000000
  );`
      : ''}
`;

export default withImage(DescriptionLogo, true);
